module.exports = __webpack_public_path__ + "img/deco-1.e721cba7.svg";